// extracted by mini-css-extract-plugin
export default {"thumb":"YsqleUj8jFwkEsGNxUl7","tagContainer":"O97roeQGWz9D08VNG5T8"};